import { MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const TOWNS = [
  "Maryville",
  "Alcoa",
  "Knoxville",
  "Sevierville",
  "Jefferson City",
  "Morristown",
  "Greeneville",
  "Johnson City",
  "Kingsport",
  "Bristol",
];

export default function ServiceArea() {
  return (
    <section
      id="service-area"
      data-testid="service-area-section"
      className="border-y border-[#122e21] bg-[#16382a]"
    >
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 md:py-32 lg:px-16">
        <SectionHeading
          overline="06 / Where we work"
          title="Knoxville to Bristol."
          testid="service-area-heading"
          dark
        />
        <Reveal>
          <p
            data-testid="service-area-copy"
            className="max-w-2xl text-base leading-relaxed text-[#c3d2bd] sm:text-lg"
          >
            Based in East Tennessee and running the whole I-81 corridor — from
            Maryville up through Knoxville, the Tri-Cities, and into Bristol.
            If you're on the corridor (or just off it), you're in range.
          </p>
        </Reveal>
        <div className="mt-12 flex flex-wrap gap-3">
          {TOWNS.map((town, i) => (
            <Reveal key={town} delay={0.05 * i}>
              <span
                data-testid={`service-area-town-${town.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-2 rounded-full border border-[#f6f1e3]/20 px-5 py-2.5 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#e9dfc8] transition-colors duration-300 hover:border-[#9fd8b4] hover:text-[#9fd8b4]"
              >
                <MapPin className="h-3.5 w-3.5 text-[#9fd8b4]" />
                {town}
              </span>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.25em] text-[#7d937f]">
            Just outside the line? Call 423-748-2012 — we may still make the
            trip.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
